// Simple Flux Protocol domain detection and theming
// TEMPORARY - Easy to remove later

/**
 * Detect if running inside a Capacitor native app (iOS or Android).
 * When bundled as a mobile app, window.Capacitor is injected by the runtime.
 * We treat ALL Capacitor native sessions as the lead portal
 * (the mobile app wraps ONLY the lead portal).
 */
const isCapacitorNative = () => {
  if (typeof window === 'undefined') return false;
  return !!(window.Capacitor && window.Capacitor.isNativePlatform());
};

const isFluxDomain = () => {
  if (isCapacitorNative()) return false; // mobile app = lead portal, not flux
  const hostname = (typeof window !== 'undefined' ? window.location.hostname : '').toLowerCase();
  return hostname.includes('fluxprotocol.ai') || hostname.includes('agent.fluxprotocol');
};

// Lead portal domain detection — mypolicyaccess.com OR Capacitor native app
const isLeadDomain = () => {
  if (isCapacitorNative()) return true; // mobile app is always the lead portal
  const hostname = (typeof window !== 'undefined' ? window.location.hostname : '').toLowerCase();
  return hostname.includes('mypolicyaccess.com');
};

const applyFluxTheme = () => {
  if (isFluxDomain()) {
    document.body.classList.add('flux-theme');
  }
};

const getLogoPath = () => {
  return isFluxDomain() ? '/Flux-Protocol-2-Cropped.webp' : null;
};

/**
 * Get the platform string: 'ios' | 'android' | 'web'
 */
const getPlatform = () => {
  if (typeof window === 'undefined') return 'web';
  if (!window.Capacitor) return 'web';
  return window.Capacitor.getPlatform() || 'web'; // 'ios', 'android', or 'web'
};

module.exports = { isFluxDomain, isLeadDomain, isCapacitorNative, getPlatform, applyFluxTheme, getLogoPath };
